<template>
  <div>
    <vue-easy-print tableShow ref="easyPrint">
      <h1 style="text-align:center">授权委托书</h1>
      <p>__________税务局：</p>
      <p>
        本人
        <span style="border-bottom:1px solid #000;padding:0 15px">{{form.name}}</span>身份证件类型:<span style="border-bottom:1px solid #000;padding:0 15px">身份证</span>,
        证件号码:<span style="border-bottom:1px solid #000;padding:0 15px">{{form.identificationNumber}}</span>为纳税人
        <span style="border-bottom:1px solid #000;padding:0 15px">{{form.name}}</span>税人识别号:________________________的法定代表人（负责人、业主），
        因为__________无法完成实名信息验证，委托__________身份证件类型:<span style="border-bottom:1px solid #000;padding:0 15px">身份证</span>证件号码:_________________________
        于_____年____月____日，到税务机关办理实名事项，办理结果及相关法律责任由委托人(法定代表人、负责人、业主)负责。
      </p>
      <p>特此授权。</p>
      <P>
        委托人签名：
        <span style="border-bottom:1px solid #000;padding:0 15px">{{form.name}}</span> 联系方式:
        <span style="border-bottom:1px solid #000;padding:0 15px">{{form.phone}}</span>
      </P>
      <p>受托人签名：__________ 联系方式: ___________________</p>
      <P style="text-align: right;margin-top:150px">纳税人<span style="border-bottom:1px solid #000;padding:0 15px">{{form.name}}</span></P>
      <p style="text-align: right">_____年 ____ 月____ 日</p>
    </vue-easy-print>
  </div>
</template>
<script>
import vueEasyPrint from "vue-easy-print";
import { getByPartyCode } from "@/api/driver";

export default {
  components: {
    vueEasyPrint
  },
  data() {
    return {
      form: {}
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      const code = this.$route.query.partyCode;
      getByPartyCode({partyCode:code}).then(response => {
        this.form = response.data;
        this.loading = false;
      });
    },
    printBtn() {
      this.$refs.easyPrint.print();
    }
  }
};
</script>